//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
import logger from "@/utils/logger";

export default {
  props: {
    showDialog: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    importType: {
      type: Number,
      required: true
    },
    mappingFields: {
      type: Array,
      required: true,
      default: () => []
    },
    settingsConfig: {
      type: Array,
      required: true,
      default: () => []
    },
    description: {
      type: String,
      required: false,
      default: ""
    },
    extraData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      internalShowDialog: false,
      settings: {},
      localMappingFields: [],
      leftMappingFields: [],
      rightMappingFields: [],
      files: [],
      isLoading: false,
      allExcelColumns: [],
      excelColumnOptions: [],
      errors: {}
    };
  },
  watch: {
    showDialog(val) {
      this.internalShowDialog = val;
      if (val) {
        this.initializeSettings();
        this.localMappingFields = JSON.parse(
          JSON.stringify(this.mappingFields)
        );
        this.splitMappingFields();
      }
    },
    internalShowDialog(val) {
      this.$emit("update:show-dialog", val);
      if (!val) {
        this.resetForm();
      }
    },
    settingsConfig: {
      handler() {
        this.initializeSettings();
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    ...mapActions("main", ["postImport", "updateLastFileImportTime"]),
    initializeSettings() {
      Object.keys(this.settings).forEach(key => {
        this.$delete(this.settings, key);
      });

      this.settingsConfig.forEach(setting => {
        this.$set(this.settings, setting.name, setting.default || null);
      });
    },
    filterOptions(val, update, setting) {
      logger.log(val)
      if (!val) {
        update(() => {
          this.settingsConfig.filter(x => x.name == setting.name)[0].filteredOptions = setting.options;
        });
        return;
      }

      const searchVal = val.toLowerCase();
      update(() => {
        this.settingsConfig.filter(x => x.name == setting.name)[0].filteredOptions = setting.options.filter(option =>
        option.label.toLowerCase().includes(searchVal));
      });
    },
    splitMappingFields() {
      this.leftMappingFields = [];
      this.rightMappingFields = [];
      this.localMappingFields.forEach((field, index) => {
        if (index % 2 === 0) {
          this.leftMappingFields.push(field);
        } else {
          this.rightMappingFields.push(field);
        }
      });
    },
    closeDialog() {
      this.internalShowDialog = false;
    },
    async handleImport() {
      if (this.isLoading) return;

      try {
        if (!this.validateForm()) return;

        this.isLoading = true;

        const file = this.files[0];
        if (!file) {
          this.errors.file = "Ingen fil er valgt.";
          return;
        }

        const base64Data = await this.convertFileToBase64(file);

        const mappings = {};
        this.localMappingFields.forEach(field => {
          const column = field.column && field.column.trim();
          if (!column) {
            return;
          }

          let fieldName = field.name;
          if (field.selectedField) {
            fieldName = field.selectedField;
          }
          mappings[fieldName] = column;
        });

        if(this.settings.activateDeactivatedProducts == null) {
          this.settings.activateDeactivatedProducts = false;
        }

        if(this.settings.headerLine == null) {
          this.settings.headerLine = false;
        }

        const payload = {
          type: this.importType,
          mapping: mappings,
          setting: this.settings,
          data: base64Data.split(",")[1],
          ...this.extraData
        };

        await this.postImport(payload);

        this.$q.notify({
          type: "positive",
          message: "Import startet!"
        });

        this.internalShowDialog = false;
        this.resetForm();
        this.updateLastFileImportTime();
      } catch (error) {
        console.error("Importfeil:", error);
        this.$q.notify({
          type: "negative",
          message:
            error.response?.data?.message || "En feil oppstod under import."
        });
      } finally {
        this.isLoading = false;
      }
    },
    validateForm() {
      this.errors = {};
      let isValid = true;

      this.settingsConfig.forEach(setting => {
        if (setting.required && !this.settings[setting.name]) {
          this.errors[setting.name] =
            setting.errorMessage || "Dette feltet er påkrevd.";
          isValid = false;
        } else {
          this.errors[setting.name] = "";
        }
      });

      this.localMappingFields.forEach(field => {
        field.errors = {};

        if (field.fieldOptions && !field.selectedField) {
          field.errors.selectedField =
            field.fieldErrorMessage || "Vennligst velg et felt.";
          isValid = false;
        }

        if (field.required && !(field.column && field.column.trim())) {
          field.errors.column =
            field.columnErrorMessage || "Vennligst velg en kolonne.";
          isValid = false;
        }
      });

      if (!this.files.length) {
        this.errors.file = "Vennligst last opp en Excel-fil.";
        isValid = false;
      }

      return isValid;
    },
    validateSetting(setting) {
      if (this.settings[setting.name]) {
        this.errors[setting.name] = "";
      }
    },
    validateMappingField(field) {
      if (field.fieldOptions && field.selectedField) {
        field.errors.selectedField = "";
      }
      if (field.column && field.column.trim()) {
        field.errors.column = "";
      }
    },
    validateColumn(field) {
      if (!field.column) return;

      const column = field.column.trim().toUpperCase();
      const matchingOption = this.allExcelColumns.find(
        option => option.value.toUpperCase() === column
      );

      if (matchingOption) {
        field.column = matchingOption.value;
        field.errors.column = "";
      } else {
        field.errors.column = `Vennligst velg en gyldig Excel-kolonne.`;
        field.column = null;
      }
    },
    convertFileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    resetForm() {
      this.initializeSettings();
      this.localMappingFields = JSON.parse(JSON.stringify(this.mappingFields));
      this.splitMappingFields();
      this.files = [];
      this.excelColumnOptions = this.allExcelColumns;
      this.errors = {};
    },
    onFilter(val, update) {
      if (!val) {
        update(() => {
          this.excelColumnOptions = this.allExcelColumns;
        });
        return;
      }

      const needle = val.toLowerCase();
      const filtered = this.allExcelColumns.filter(option =>
        option.label.toLowerCase().includes(needle)
      );

      update(() => {
        this.excelColumnOptions = filtered;
      });
    },
    generateExcelColumnOptions() {
      const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      const columns = [];

      for (let i = 0; i < letters.length; i++) {
        const letter = letters[i];
        columns.push({ label: letter, value: letter });
      }

      for (let i = 0; i < letters.length; i++) {
        for (let j = 0; j < letters.length; j++) {
          const letter = letters[i] + letters[j];
          columns.push({ label: letter, value: letter });
        }
      }

      return columns;
    },
    onFilesAdded(newFiles) {
      this.errors.file = "";

      const validTypes = [
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ];
      const file = newFiles[0];
      if (file && !validTypes.includes(file.type)) {
        this.errors.file =
          "Ugyldig filtype. Vennligst last opp en .xls eller .xlsx fil.";
        this.$refs.uploader.removeFile(file);
        return;
      }

      this.files = [file];
    },
    onFilesRemoved() {
      this.files = [];
      if (!this.files.length) {
        this.errors.file = "Vennligst last opp en Excel-fil.";
      }
    },
    getComponentType(setting) {
      switch (setting.type) {
        case "select":
          return "q-select";
        case "toggle":
          return "q-toggle";
        case "input":
          return "q-input";
        default:
          return "div";
      }
    },
    IsComponentFilterable(setting) {
      if(setting["filterable"] == undefined)
        return false;

      return setting["filterable"];
    },
    getComponentProps(setting) {
      const commonProps = {
        label: setting.label,
        dense: true,
        outlined: true,
        emitValue: true,
        mapOptions: true,
        hideBottomSpace: true,
        required: setting.required
      };

      if (setting.type === "select") {
        return {
          ...commonProps,
          options: setting.options,
          optionLabel: setting.optionLabel || "label",
          optionValue: setting.optionValue || "value"
        };
      } else if (setting.type === "toggle") {
        return {
          ...commonProps,
          falseValue: null,
          leftLabel: true
        };
      } else if (setting.type === "input") {
        return {
          ...commonProps,
          type: setting.inputType || "text"
        };
      } else {
        return commonProps;
      }
    }
  },
  mounted() {
    this.allExcelColumns = this.generateExcelColumnOptions();
    this.excelColumnOptions = this.allExcelColumns;
  }
};
